import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable, of, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {AuthenticationService} from './authentication.service';
import {Router} from '@angular/router';
import {marker} from "@biesbjerg/ngx-translate-extract-marker";
import {TranslateService} from "@ngx-translate/core";
import {isNil} from "lodash-es";

@Injectable()
export class UnauthorizedInterceptor implements HttpInterceptor {
  constructor(
    private authenticationService: AuthenticationService,
    private translateService: TranslateService,
    private router: Router,
  ) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError(err => {
        if (err.status === 401 || request.url.includes('organizations/null')) {
          this.authenticationService.clearLoginState();
          // Mark auth as initialized to allow navigation to login
          this.authenticationService.markAuthAsInitialized();
          this.router.navigate(['login']);
          return of(null);
        }
        else if (err.status === 404 && request.url.includes('/public-forms/')) {
          this.router.navigate(['public-form/not-found']);
          return of(null);
        }
        else {
          if (!isNil(err.error?.errorMessage)) {
            this.translateService.stream(marker(err.error?.errorMessage)).subscribe((errMsg) => {
              err.error.errorMessage =  errMsg.toString()
            });
          }
          return throwError(err);
        }
      }),
    );
  }
}
